// extracted by mini-css-extract-plugin
module.exports = {"body":"HeaderAndFooter_body__3KFQm","renderArea":"HeaderAndFooter_renderArea__60JWW"};